import { Box } from '@mui/material'
import AgentProfileAvatar from '@/components/Agents/AgentProfileAvatar'
import styles from './MentionSuggestionsPopover.module.scss'

export function MentionSuggestionsAgentList({ agents, usersLength, activeIndex, onHighlight, onSelect }) {
  return agents.map((agent, index) => {
    const flatIndex = usersLength + index
    const active = activeIndex === flatIndex
    return (
      <button
        key={agent.id}
        type="button"
        role="option"
        aria-selected={active}
        className={`${styles.row} ${active ? styles.rowActive : ''}`}
        onMouseEnter={() => onHighlight(flatIndex)}
        onMouseDown={(e) => {
          e.preventDefault()
          onSelect({ id: agent.id, kind: 'agent', label: agent.label })
        }}
      >
        <AgentProfileAvatar
          size={24}
          agentId={agent.id}
          name={agent.name}
          avatarSrc={agent.avatarSrc}
          avatarAlt={agent.avatarAlt}
        />
        <Box className={styles.rowText}>
          <Box component="span" className={styles.rowPrimary}>
            {agent.label}
          </Box>
          <Box component="span" className={styles.rowSecondary}>
            {agent.subtitle}
          </Box>
        </Box>
      </button>
    )
  })
}
